import { Component, inject, Input, OnInit } from '@angular/core';
import { ApiOfferSet, OfferSetsApi } from 'api';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contribution-pog-bar',
  templateUrl: './contribution-pog-bar.component.html',
  styleUrls: ['./contribution-pog-bar.component.scss']
})
export class ContributionPogBarComponent implements OnInit {
  private offerSetApi = inject(OfferSetsApi);
  private route = inject(ActivatedRoute);

  @Input() offerSet: ApiOfferSet;

  async ngOnInit() {
    if (!this.offerSet) {
      const offerSetId = this.route.snapshot.queryParamMap.get('offerSetId');
      const defaultParam = this.route.snapshot.queryParamMap.get('default');
      const defaultParamBool = defaultParam === 'true';
      this.offerSet = await this.offerSetApi.get(offerSetId, defaultParamBool).toPromise();
    }
  }

  ratio() {
    if (!this.offerSet) return 0;
    return Math.min(this.offerSet.contribution_goal_current_value / this.offerSet.contribution_goal, 1);
  }
}
